import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class DestinatairesService {

  private baseUrl = environment.APIBI_URI;
  bp_destinataires='/api/destinataires';

  constructor( private http: HttpClient ) { }

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }


getRapportsByDo(DO: string): Observable<any> {

    const headers = this.getAuthHeaders();
    const params = new HttpParams().set('DO', DO);

    return this.http.get(`${this.baseUrl}${this.bp_destinataires}/rapports`, { headers, params }).pipe(
      catchError(this.handleError)
    );
  }

  getDestinataires(DO: string): Observable<any> {
    const headers = this.getAuthHeaders();
    const params = new HttpParams().set('DO', DO);

    return this.http.get(`${this.baseUrl}${this.bp_destinataires}/show`, { headers, params }).pipe(
      catchError(this.handleError)
    );
  }


updateDestinataires(
  DO: string,
  toEmails: string[],
  ccEmails: string[],
  context?: { filtre?: string; report_type?: string }
): Observable<any> {
  const headers = this.getAuthHeaders();
  let params = new HttpParams().set('DO', DO);

  const body: any = {
    to: toEmails,
    cc: ccEmails
  };

  if (context?.filtre) {
    body.filtre = context.filtre;
  }
  if (context?.report_type) {
    body.report_type = context.report_type;
  }

  return this.http.post(
    `${this.baseUrl}${this.bp_destinataires}/update`,
    body,
    { headers, params }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}


 private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur inconnue est survenue';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Erreur: ${error.error.message}`;
    } else {
      errorMessage = this.getServerErrorMessage(error);
    }

    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 400:
        return error.error?.error || 'Requête incorrecte';
      case 404:
        return 'Ressource non trouvée';
      case 423:
        return 'Fichier verrouillé, veuillez réessayer plus tard';
      case 500:
        return 'Erreur interne du serveur';
      default:
        return error.message || 'Erreur serveur inconnue';
    }
  }

}





